import moment from 'moment';
import { toVertexLogoURL } from '~/utils/transform.js';
import { getOrganizatioTypesByID, getConfirmedAffiliates } from '~/state/ducks/app/selectors.js';
import mapping from '~/utils/mapping.json';


export const orgToState = ({
    licenses = [],
    organization_type_id,
    product_id,
    created,
    modified,
    logo_id,
    logo_url,
    address = {},
    contact = {},
    ...rest
}, getState) => {
    const state = getState();
    return {
        licenses: licenses.map(l => l.product.id.toString()),
        organization_type_id,
        organization_type: getOrganizatioTypesByID(state).get(organization_type_id),
        product_id,
        product: mapping.license.by_id[product_id],
        created: moment(created).format('lll'),
        modified: moment(modified).format('lll'),
        logo_id,
        logo_url,
        logo: toVertexLogoURL({ logo_id, logo_url }),
        address,
        contact,
        portal_affiliates: getConfirmedAffiliates(state),
        ...rest,
    };
};

export const logoUrl = affiliates => affiliates.map((aff) => {
    const { logo_id, logo_url } = aff;
    return {
        logo: toVertexLogoURL({ logo_id, logo_url }),
        ...aff,
    };
});

export const listOrg = orgs => orgs.map(({
    id,
    name,
    logo_id,
    logo_url,
    created,
    modified,
}) => ({
    id,
    name,
    created: moment(created).format('lll'),
    modified: moment(modified).format('lll'),
    logo_id,
    logo_url,
    logo: toVertexLogoURL({ logo_id, logo_url }),
}));
